import { AlertTriangle, Info } from 'lucide-react'
import { ParseQuality } from '../types/preview'
import './ParseQualityNotice.css'

interface Props {
  quality?: ParseQuality | null
}

/**
 * Zeigt an, wenn beim Lesen des Exports etwas nicht sauber aufging.
 * Bewusst nur ein Hinweis: Der Kauf bleibt jederzeit möglich — der Nutzer
 * sieht in der Vorschau selbst am besten, ob das Ergebnis für ihn passt.
 */
export function ParseQualityNotice({ quality }: Props) {
  if (!quality || quality.quality === 'ok' || quality.warnings.length === 0) return null

  const severe = quality.quality === 'poor'

  return (
    <div className={`pq-notice ${severe ? 'pq-notice--severe' : ''}`} role="status">
      <span className="pq-icon" aria-hidden="true">
        {severe ? <AlertTriangle size={18} /> : <Info size={18} />}
      </span>
      <div className="pq-body">
        <p className="pq-title">
          {severe
            ? 'Dieser Export ließ sich nur teilweise lesen'
            : 'Ein Hinweis zu diesem Export'}
        </p>
        <ul className="pq-list">
          {quality.warnings.map((w, i) => <li key={i}>{w}</li>)}
        </ul>
        <p className="pq-hint">
          Prüf am besten kurz die Vorschau. Sieht sie richtig aus, kannst du normal fortfahren –
          wenn nicht, schreib uns an{' '}
          <a href="mailto:kontakt@chatarchiv.de">kontakt@chatarchiv.de</a> und schick uns die Datei.
        </p>
      </div>
    </div>
  )
}
